"use client";

import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

interface LightboxProps {
  images: string[];
  thumbnail?: {
    width: number;
    height: number;
  };
}

const ImageLightbox: React.FC<LightboxProps> = ({ images, thumbnail }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openLightbox = (index: number) => {
    setIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      <div className="image-gallery">
        {images.map((image, idx) => (
          <img
            key={idx}
            src={image}
            width={thumbnail?.width}
            height={thumbnail?.height}
            alt={`Gallery Image ${idx + 1}`}
            onClick={() => openLightbox(idx)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={images.map((src) => ({ src }))}
          plugins={[Thumbnails]}
          index={index}
        />
      )}
    </div>
  );
};

export default ImageLightbox;
